import LazyLoadImg from "components/LazyLoadImg";
import { RouteName } from "constant/routeNames";
import { BiChevronRight } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { MiniPackagesResponse } from "services/subscription/types";
import { displayTimeFormat, hexToRgba } from "utils/helperFuncs";

const MiniPackagesCard = ({ card }: { card: MiniPackagesResponse }) => {
  const navigate = useNavigate();
  return (
    <div
      className={`group w-full max-w-[222px] mx-auto aspect-[222/285] rounded-[17px] relative overflow-hidden flex flex-col justify-end cursor-pointer transition-all duration-300 ease-out hover:-translate-y-1.5 hover:shadow-2xl ${
        card?.is_subscribed ? "shadow-lg" : ""
      }`}
      style={{
        boxShadow: card?.is_subscribed ? `0 0 30px ${card.color}` : undefined,
      }}
      onClick={() =>
        navigate(
          RouteName.packageDetailsPageRoute.replace(
            ":slug",
            card.slug.toString(),
          ),
          { state: { card: card } },
        )
      }
    >
      {/* Background image layer */}
      <LazyLoadImg
        imgSrc={card.thumbnail}
        imgAlt="Card background"
        imgHeight="100%"
        imgWidth="100%"
        // Make the lazy-load wrapper <span> fill the whole card
        wrapperProps={{
          style: {
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            display: "block",
            zIndex: 0,
          },
        }}
        className="object-cover w-full h-full transition-transform duration-500 ease-out group-hover:scale-110"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center",
          borderRadius: "17px",
        }}
      />

      {/* Gradient overlay on top of image */}
      <div
        className="absolute inset-0 transition-opacity duration-300 group-hover:opacity-90"
        style={{
          background: `linear-gradient(to top, ${hexToRgba(card?.color || "#DE1E17", 0.8)}, transparent 45%)`,
          zIndex: 1,
        }}
      />

      {/* Darkening sheen that fades in on hover for extra depth */}
      <div className="absolute inset-0 z-[1] bg-black/0 transition-colors duration-300 group-hover:bg-black/20" />

      {/* Ring highlight on hover */}
      <div
        className="absolute inset-0 z-[2] rounded-[17px] ring-0 ring-inset transition-all duration-300 group-hover:ring-2 group-hover:ring-white/20"
        style={{ pointerEvents: "none" }}
      />

      {/* Content */}
      <div className="relative z-20 w-full p-3 transition-transform duration-300 group-hover:-translate-y-0.5">
        <p className="text-sm font-bold text-white sm:text-base line-clamp-1">
          {card.title}
        </p>

        <div className="flex items-center justify-between w-full text-white text-[10px] font-normal">
          {/* <p>{card.description}</p> */}
          <p>
            ${card.price}/{displayTimeFormat(card.plan_period_format)}
          </p>
        </div>

        {/* Subscribe button */}
        <button
          className="flex h-[32px] items-center justify-between w-full text-white text-[11px] font-normal rounded-lg py-2 px-[7px] mt-1 transition-all duration-300 group-hover:shadow-lg hover:brightness-110"
          style={{ backgroundColor: card?.color || "#DE1E17" }}
        >
          {card?.is_subscribed ? "Subscribed" : "Subscribe"}
          <BiChevronRight className="flex-shrink-0 transition-transform duration-300 group-hover:translate-x-0.5" />
        </button>
      </div>
    </div>
  );
};

export default MiniPackagesCard;
